<script setup>
import { ref } from 'vue'
import { moveImage } from './catalog.mjs'
import { unavailableMediaLibrary } from './mediaLibrary.mjs'

const props = defineProps({
  imagePaths: { type: Array, default: () => [] },
  displayUrls: { type: Array, default: () => [] },
  adapter: { type: Object, default: () => unavailableMediaLibrary },
  disabled: Boolean,
})
const emit = defineEmits(['update:imagePaths'])
const loading = ref(false)

function move(from, to) { emit('update:imagePaths', moveImage(props.imagePaths, from, to)) }
function remove(index) {
  if (props.imagePaths.length <= 1) return
  emit('update:imagePaths', props.imagePaths.filter((_, itemIndex) => itemIndex !== index))
}
async function select() {
  if (!props.adapter.isAvailable() || typeof props.adapter.select !== 'function') return
  loading.value = true
  try {
    const items = await props.adapter.select({ multiple: true })
    emit('update:imagePaths', [...props.imagePaths, ...items.map((item) => item.path)])
  } finally { loading.value = false }
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h3 class="h5 mb-1">Зображення товару</h3>
        <p class="text-muted small mb-0">Перше зображення є основним.</p>
      </div>
      <button v-if="adapter.isAvailable()" class="btn btn-outline-primary" type="button" :disabled="disabled || loading" @click="select">
        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>Обрати з медіатеки
      </button>
    </div>
    <div v-if="!adapter.isAvailable()" class="alert alert-secondary">
      Медіатека зараз недоступна: backend не надає API перегляду або завантаження. Наявні зображення можна впорядковувати й видаляти.
    </div>
    <div v-if="imagePaths.length === 1" class="alert alert-warning small">Backend не приймає порожній список media paths, тому останнє зображення не можна видалити до зміни API-контракту.</div>
    <div v-if="!imagePaths.length" class="catalog-empty border rounded p-5 text-center text-muted">Зображень ще немає</div>
    <div v-else class="row g-3">
      <div v-for="(path, index) in imagePaths" :key="`${path}-${index}`" class="col-12 col-sm-6 col-xl-4">
        <div class="card h-100">
          <img :src="displayUrls[index] || ''" class="card-img-top catalog-media-image" :alt="`Зображення товару ${index + 1}`">
          <div class="card-body">
            <span v-if="index === 0" class="badge bg-primary mb-2">Основне</span>
            <div class="small text-break" :title="path">{{ path }}</div>
          </div>
          <div class="card-footer d-flex gap-2">
            <button class="btn btn-sm btn-outline-secondary" type="button" aria-label="Перемістити ліворуч" :disabled="disabled || index === 0" @click="move(index, index - 1)"><i class="bi bi-arrow-left"></i></button>
            <button class="btn btn-sm btn-outline-secondary" type="button" aria-label="Перемістити праворуч" :disabled="disabled || index === imagePaths.length - 1" @click="move(index, index + 1)"><i class="bi bi-arrow-right"></i></button>
            <button class="btn btn-sm btn-outline-danger ms-auto" type="button" aria-label="Видалити з товару" :disabled="disabled || imagePaths.length === 1" @click="remove(index)"><i class="bi bi-trash"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
